/* HUD "inkl. moms" v2 (fristående paket 2026-10-25)
 * Lägger till "inkl. moms" efter priser som ritas av appar i webbläsaren (t.ex. Globo-filtret på kollektion och sök),
 * där temats snippets/price.liquid inte körs. Samma .price .price-container-struktur och samma span som Liquid-versionen.
 * Ändrar inga priser. Laddas bara för SE/SEK/svensk locale och icke-B2B-kunder (snippets/hud-moms-text.liquid, head: true).
 * Extra skydd i webbläsaren (om skriptet ändå skulle laddas): avbryter för SparkLayer-inloggning, annan valuta/land/språk
 * och när momsväxlaren (hud-vat) finns; hoppar över B2B-only-ytor, rutor med "exkl./excl. moms" och rutor med momsväxlarens etikett.
 */
(function () {
  'use strict';
  if (window.__hudMomsText) return;
  window.__hudMomsText = true;
  var SKIP = '.hudlp,[data-hud-moms-skip],[data-spark="b2b-only"],spark-pdp,spark-product-card,script,style,noscript,template,[contenteditable]';
  var EXKL = /\b(exkl|excl|exkl\.|ex\.?\s*moms|ex\.?\s*vat|excluding)\b/i;
  function allowed() {
    var S = window.Shopify || {};
    var cur = S.currency && S.currency.active;
    if (cur && cur !== 'SEK') return false;
    if (S.country && S.country !== 'SE') return false;
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (lang && lang.indexOf('sv') !== 0) return false;
    var so = window.sparkOptions;
    if (so && so.auth && so.auth.token) return false; /* SparkLayer-inloggad = B2B */
    if (vat()) return false; /* momsväxlaren ersätter paketet */
    return true;
  }
  function label() {
    var s = document.createElement('span');
    s.className = 'hud-moms-text';
    s.setAttribute('data-hud-moms-js', '');
    s.textContent = 'inkl. moms';
    return s;
  }
  function placeAfterCurrent(pc) {
    /* m4: direkt efter det gällande priset (<b>), inte efter det överstrukna förpriset */
    var b = pc.querySelector(':scope > b, :scope > .price-item--sale, :scope > .price-sale > b');
    if (b && b.parentNode) { b.parentNode.insertBefore(label(), b.nextSibling); return; }
    var unit = pc.querySelector(':scope > .unit-price');
    if (unit) pc.insertBefore(label(), unit); else pc.appendChild(label());
  }
  function vat() {
    return !!(window.__hudVatInit || document.querySelector('.hud-vat-toggle,[data-hud-vat-label],.hud-vat-label'));
  }
  function run() {
    if (!allowed()) {
      if (vat()) { /* momsväxlaren laddades efter oss: ta bort våra JS-etiketter så det inte blir dubbeltext */
        var mine = document.querySelectorAll('.hud-moms-text[data-hud-moms-js]');
        for (var k = 0; k < mine.length; k++) mine[k].parentNode.removeChild(mine[k]);
      }
      return;
    }
    var list = document.querySelectorAll('.price .price-container');
    for (var i = 0; i < list.length; i++) {
      var pc = list[i];
      if (pc.querySelector('.hud-moms-text')) continue;
      if (!pc.querySelector('.trans-money')) continue;
      if (pc.closest(SKIP)) continue;
      if (pc.querySelector('[data-hud-vat-label],.hud-vat-label')) continue;
      if (EXKL.test(pc.textContent || '')) continue;
      placeAfterCurrent(pc);
    }
  }
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(function () { queued = false; run(); });
  }
  function start() {
    run();
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var a = muts[i].addedNodes;
          for (var j = 0; j < a.length; j++) {
            if (a[j].nodeType === 1 && !(a[j].classList && a[j].classList.contains('hud-moms-text'))) { schedule(); return; }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
